import application_contants from '../../contants/application_contants';

const BhashiniData = [
    
        application_contants.bhashiniimg1,application_contants.bhashiniimg2,application_contants.bhashiniimg3,
];


export default BhashiniData;